import { Children, Fragment, isValidElement } from "react";
import { composeRefs } from "@exonn/hooks";
import type { TextFieldProps } from "@mui/material";
import type { ReactNode } from "react";
import { InputV2 } from "src/components/InputV2/InputV2.tsx";

type Props = Pick<
  TextFieldProps,
  | "InputProps"
  | "onChange"
  | "className"
  | "onClick"
  | "onBlur"
  | "onFocus"
  | "inputRef"
  | "disabled"
  | "placeholder"
  | "inputProps"
> & {
  value: string;
  defaultValue: string;
  floatingError?: boolean;
  customError: string;
};

const hasChildren = (element: ReactNode): boolean =>
  Children.toArray(element).some((child) =>
    isValidElement(child)
      ? child.type === Fragment
        ? hasChildren(child.props.children)
        : true
      : !!child,
  );

export const PickerTextField = (props: Props) => {
  const {
    InputProps: { ref, startAdornment, endAdornment } = {},
    onChange,
    value,
    className,
    onClick,
    onBlur,
    onFocus,
    inputRef,
    disabled,
    placeholder,
    defaultValue,
    inputProps,
    customError,
    floatingError = false,
    inputProps: { onKeyDown, onPaste, style: inputStyle } = {},
  } = props;

  return (
    <InputV2
      error={customError}
      style={inputStyle}
      className={className}
      ref={composeRefs(inputProps?.ref, ref, inputRef)}
      value={value}
      defaultValue={defaultValue}
      floatingError={floatingError}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onPaste={onPaste}
      onFocus={onFocus}
      onBlur={onBlur}
      onClick={onClick}
      disabled={disabled}
      placeholder={placeholder}
      startAdornment={startAdornment}
      endAdornment={hasChildren(endAdornment) && endAdornment}
    />
  );
};
